export default __webpack_public_path__ + "static/media/close.d8042d41.svg";